import { type DocumentNode } from '@apollo/client';

import type { VisibilityEntity } from '@modules/_shared/components/visibility-drawer/types';

export type NormalizedReview = {
  id: string;
  rating?: number | null;
  reviewText?: string | null;
  completedAt?: string | null;
  displayName?: string | null;
  ownerAnswer?: string | null;
  ownerAnswerDate?: string | null;
  isVerified: boolean;
};

export type NormalizedTransaction = {
  id: string;
  propertyId?: string | null;
  signatureDate?: string | null;
  purchasePrice?: number | null;
  propertyType?: string | null;
  numberOfRooms?: number | null;
  locality?: string | null;
  imageUrl?: string | null;
  isVerified: boolean;
  soldByAgent?: string | null;
  soldByTeam?: string | null;
};

export type QueryConfig = {
  query: DocumentNode;
  getVariables: (params: QueryParams) => Record<string, unknown>;
};

export type QueryParams = {
  entityId: string;
  teamId?: string;
  limit: number;
  offset: number;
  skip?: boolean;
};

export type DataTransformer<TData, TNormalized> = (
  data: TData,
  options?: { limit?: number; offset?: number },
) => {
  items: TNormalized[];
  totalCount: number; // Note: Currently all transformers return 0, counts are fetched separately
  averageRating?: number;
};

export const getEntityType = (entity: VisibilityEntity) => {
  return entity.__typename;
};
